export default state => {
  if (!state.subscriptions.current) {
    return undefined;
  }

  return state.subscriptions.current.family;
};
